import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BiLinkExternal } from "react-icons/bi";
import Badge from "react-bootstrap/Badge";

function ProjectCards({imgPath,link,title,description,isBlog,techstacks}) {
  console.log(techstacks);
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={imgPath} alt="card-img" style={{height:'200px'}} />
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {description}
        </Card.Text>
       {
         techstacks && techstacks.map((techstack,index)=>{ 
          return ( 
          <Badge key={index} pill bg="secondary"  style={{marginRight:'5px'}}>{techstack}</Badge>
         )})
        }
        <br/>
        <br/>
                <Button variant="primary" href={link} target="_blank">
      
          <BiLinkExternal /> &nbsp;
          {isBlog ? "View Blog" : "View Project"}
        </Button>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;